var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { OnInit, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { ViewTreeNode } from 'src/app/engine/models/view.tree-node';
import { FlyToNode } from 'src/app/engine/state/engine.actions';
import { Store, Select } from '@ngxs/store';
import { EngineState } from 'src/app/engine/state/engine.state';
import { BdGraphService } from 'src/lib/graph/graph.service';
import { BdGraph } from 'src/lib/graph/graph.model';
import { SetObjectVisibility, SetObjectPickable } from 'src/app/edit/state/edit.actions';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { EngineNodesState } from 'src/app/engine/state/nodes/engine.nodes.state';
import { CollapseNode, ExpandNode, CheckNode, CheckInverseNodes, SetCheckedNodes, HideInverse, ToggleInversePickableNodes } from 'src/app/engine/state/nodes/engine.nodes.actions';
import { TreeTheme } from '../tree/tree.component';
import { GraphUtils } from 'src/lib/graph/graph-utils';
import { environment } from 'src/environments/environment';
var TreeNestedNodeComponent = /** @class */ (function () {
    function TreeNestedNodeComponent(store, graphService, changeDetection) {
        this.store = store;
        this.graphService = graphService;
        this.changeDetection = changeDetection;
        this.treeTheme = TreeTheme;
        this.isLoft = environment.exportType === 'module';
        this.nested = true;
        this.theme = TreeTheme.Dark;
        this.checked = false;
        // DOM friendly version of node ID
        // nodeID may include pipe characters, which cause errors with querySelector
        this.sanitizedID = '';
        this.ngUnsubscribe = new Subject();
    }
    Object.defineProperty(TreeNestedNodeComponent.prototype, "node", {
        get: function () {
            return this._node;
        },
        set: function (value) {
            this._node = value;
            this.sanitizedID = this.graphService.sanitizeNodeID(this.node.id);
        },
        enumerable: true,
        configurable: true
    });
    TreeNestedNodeComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.checkedNodesIds$
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function (nodeIds) {
            _this.checked = nodeIds.some(function (id) { return id === _this.node.id; });
            _this.changeDetection.markForCheck();
        });
    };
    TreeNestedNodeComponent.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    TreeNestedNodeComponent.prototype.handleExpandClick = function (node, expanded) {
        (expanded) ?
            this.store.dispatch(new CollapseNode(node)) :
            this.store.dispatch(new ExpandNode(node));
    };
    TreeNestedNodeComponent.prototype.handleLabelClick = function (event, node) {
        if (event.shiftKey) {
            this.checkNode(node);
        }
        else {
            this.setCheckedNodes(node);
        }
    };
    TreeNestedNodeComponent.prototype.isChecked = function (node) {
        return this.store.selectSnapshot(EngineNodesState.getCheckedNodes)
            .some(function (checkedNode) { return checkedNode.id === node.id; });
    };
    TreeNestedNodeComponent.prototype.checkNode = function (node, checked) {
        if (typeof checked === 'undefined') {
            // When not explicitly defiend, toggle the node checked state
            checked = !this.isChecked(node);
        }
        this.store.dispatch(new CheckNode(node, checked));
    };
    TreeNestedNodeComponent.prototype.checkInverse = function (node) {
        this.store.dispatch(new CheckInverseNodes([node]));
    };
    TreeNestedNodeComponent.prototype.setCheckedNodes = function (node, checked) {
        if (typeof checked === 'undefined') {
            // When not explicitly defiend, toggle the node checked state
            checked = !this.isChecked(node);
        }
        var nodes = checked ? [node] : [];
        this.store.dispatch(new SetCheckedNodes(nodes));
    };
    TreeNestedNodeComponent.prototype.countChildren = function (node) {
        return GraphUtils.getSuccessors(this.graph, node.id).length;
    };
    TreeNestedNodeComponent.prototype.hasChildren = function (node) {
        return this.countChildren(node) > 0;
    };
    TreeNestedNodeComponent.prototype.flyToNode = function (node) {
        this.store.dispatch(new FlyToNode(node));
    };
    TreeNestedNodeComponent.prototype.hideNode = function (node) {
        this.store.dispatch(new SetObjectVisibility([node], false));
    };
    TreeNestedNodeComponent.prototype.hideInverse = function (node) {
        var viewGraph = this.store.selectSnapshot(EngineState.getViewGraph);
        this.store.dispatch(new HideInverse([node], viewGraph));
    };
    TreeNestedNodeComponent.prototype.showNode = function (node) {
        this.store.dispatch(new SetObjectVisibility([node], true));
        this.changeDetection.markForCheck();
    };
    TreeNestedNodeComponent.prototype.toggleVisible = function (node, show) {
        show = (typeof show === 'undefined') ? !node.boolState.shown : show;
        this.store.dispatch(new SetObjectVisibility([node], show));
        this.changeDetection.markForCheck();
    };
    TreeNestedNodeComponent.prototype.togglePickable = function (node, pickable) {
        this.store.dispatch(new SetObjectPickable([node], pickable));
        this.changeDetection.markForCheck();
    };
    TreeNestedNodeComponent.prototype.toggleInversePickable = function (node, pickable) {
        var viewGraph = this.store.selectSnapshot(EngineState.getViewGraph);
        this.store.dispatch(new ToggleInversePickableNodes([node], viewGraph, pickable));
    };
    __decorate([
        Select(EngineNodesState.getCheckedNodeIds),
        __metadata("design:type", Observable)
    ], TreeNestedNodeComponent.prototype, "checkedNodesIds$", void 0);
    return TreeNestedNodeComponent;
}());
export { TreeNestedNodeComponent };
